import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { Loader } from '@pwc/pwc-deals-ui';
import {
  getProjectIsLoaded,
  getProjectLoading,
  isStructuredV2Enabled,
} from '../../../project/projectSlice';

export const RedirectV1V2 = ({ children }: { children: ReactNode }) => {
  const { projectId } = useParams<{ projectId: string }>();
  const isLoading = useSelector(getProjectLoading);
  const isLoaded = useSelector(getProjectIsLoaded);

  const enableStructuredV2 = useSelector(isStructuredV2Enabled);
  if (enableStructuredV2 && !isLoading && isLoaded) {
    const path = window.location.pathname;

    const isReportPreviewPage = path.includes('/report-preview/');
    const isReportPreviewStructuredPage = window.location.search.includes(
      'isUnStructured=false'
    );
    if (isLoading) {
      return <Loader />;
    }
    if (
      !isReportPreviewPage ||
      (isReportPreviewPage && isReportPreviewStructuredPage)
    ) {
      if (isReportPreviewPage) {
        let pathSwapped = path.replace('/analyses/', '/template-analyses/');
        pathSwapped = pathSwapped.replace(
          '/report-preview/ANALYSIS/latest',
          '/report-preview/latest'
        );
        return <Redirect to={pathSwapped} />;
      }

      const isStructuredViewPage = !!path.match(
        /(quality-of-earnings$)|(net-working-capital$)|(debt-debt-like$)/
      );
      if (isStructuredViewPage) {
        return <Redirect to={`/projects/${projectId}/analyses/add-type`} />;
      }
    }
  }

  return children;
};
